import gql from "graphql-tag";
import {Feature, Geometry} from "geojson";
import {IEntityGeomLayerResponse, IEntityNode} from "../types";
import {client} from "./client";
import * as wkt from 'terraformer-wkt-parser';
import {formatLayers} from "../utils/formatLayers";

const SRID = 4326;

export interface IEntitySearchResultNode {
    geoType: string;
    type: string;
    fullUid: string;
    layername: string;
    name: string;
    membertype: string;
    websiteurl: string;
    notes: string;
    instruc: string;
    description: string;
}

const getQueryWithGeom = (geometry: Geometry, layers: string[]) => getQuery(wkt.convert(geometry), layers);

const getQuery = (geometry: string, layers: string[] = []) => gql`
    {
        searchGeomEntitiesByLayer (search : "SRID=${SRID};${geometry}", layers: ${formatLayers(layers)}) {
            nodes {
                geoType
                fullUid
                name
                membertype
                websiteurl
                notes
                instruc
                description
                datelastchanged
                layerByLayerid {
                    layername,
                    type
                }
                entitycontactsByFullUid {
                    nodes {
                        contactByPocid {
                            pocid
                            name
                            cell
                            land
                            email
                            pubconinfo
                            instruc
                            datelastchanged
                            document
                        }
                    }
                }
            }
        }
    }
`;

export async function searchGeomEntitiesByLayer (geometryOrFeature: Geometry | Feature, layers: string[]):
    Promise<IEntityNode[]> {
    let geometry: Geometry = (geometryOrFeature.type === "Feature") ? geometryOrFeature.geometry : geometryOrFeature;
    try {
        const result: IEntityGeomLayerResponse = await client.query({
            query: getQueryWithGeom(geometry, layers)
        });
        console.log(result);
        return mapNodes(result.data.searchGeomEntitiesByLayer.nodes);
    } catch (e) {
        console.error(e);
        return [];
    }
}

function mapNodes (nodes: IEntityGeomLayerResponse['data']['searchGeomEntitiesByLayer']['nodes'] = []): IEntityNode[] {
    return nodes.map(node => ({
        ...node, ...node.layerByLayerid,
        contacts: node!.entitycontactsByFullUid!.nodes.map(node => node.contactByPocid)
    }))
}

